// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  // {
  //   title: 'dashboard',
  //   path: '/dashboard/app',
  //   icon: icon('ic_analytics'),
  // },
  {
    title: 'Requests',
    path: '/dashboard/user',
    icon: icon('ic_user'),
  },
  {
    title: 'Change Password',
    path: '/dashboard/change-password',
    icon: icon('ic_lock'),
  },
  {
    title: 'logout',
    path: '/',
    icon: icon('ic_lock'),
  },
  
];

export default navConfig;
